<template>
  <div id="attendance-event">
    <div class="attendance-img-wrapper">
      <div class="apt"></div>
      <div class="d-grid">
        <div :class="{ seven: i === 7 }" class="attendance_wrap" v-for="i in 7" :key="i">
          <div v-if="i === 7" class="title">7day</div>
          <img
            :src="`${$s3}/img/common/attendance/modal/event_${isActived(i, 0)}${
              isDouble ? '_double' : ''
            }.webp?${$ver}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarEvent2024',
  props: ['cnt_attendance'],
  computed: {
    isDouble() {
      return !!this.$store.state.attendanceEvent?.isDouble;
    },
  },
  methods: {
    getLastDay(num) {
      if (num === 7) return 7 <= this.cnt_attendance ? 'last_day' : 'last_default';
    },
    isActived(num) {
      if (num === 7) return this.getLastDay(num);
      if (num <= this.cnt_attendance) return `day${num}`;

      return 'default';
    },
  },
};
</script>

<style lang="scss" scoped>
#attendance-event {
  margin: 0;
  padding: 20px 24px 0 24px;
  text-align: center;

  .block-content {
    padding: 0;
  }
  .row {
    margin: 0 -4px;
  }
  #attendance_title {
    font-size: 16px;
    color: #001c41;
    font-weight: 600;
    margin-bottom: 10px;
  }
  #attendance_subtitle {
    font-size: 13px;
    margin-bottom: 3px;
    color: #333333;
  }
  .attendance_block {
    padding: 0;
    border: 1px solid #ededed;
  }
  img {
    width: 100%;
  }
  #attendance_info {
    color: #666666;
    font-size: 10px;
    text-align: left;
    margin-top: 12px;
  }
  .attendance-img-wrapper {
    display: grid;
    grid-template-columns: 1.2fr 3fr;

    .apt {
      background: bottom / contain no-repeat url($s3-url + '/img/common/attendance/modal/apt.webp?' + $version);
      border: 2px solid #ededed;
      border-right: 0;
    }

    .d-grid {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr) auto;
      border: 1px solid #ededed;

      .attendance_wrap {
        position: relative;
        display: grid;
        place-items: center;
        border: 1px solid #ededed;
        padding: 0.5rem;

        &.seven {
          grid-column: 1 / span 2;
        }

        .title {
          font-size: 10px;
          color: #fff;
          background: #000;
          position: absolute;
          padding: 2px 9px;
          padding-bottom: 3px !important;
          top: 5%;
          left: 7%;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
